import { call, put, select } from 'redux-saga/effects';
import queryString from 'query-string';
import { API } from '../../api';

const getSearchQuery = ({ searchQuery }) => searchQuery;
const getServerConfig = ({ serverConfig }) => serverConfig;
const getMapHoverProps = ({ mapHoverProps }) => mapHoverProps;

export function* fetchSearch() {
  try {
    const qs = yield select(getSearchQuery);
    const mapHoverProps = yield select(getMapHoverProps);
    const props = mapHoverProps.length
      ? mapHoverProps
      : ['parcel_id', 'add_combo', 'owner_name'];

    const serverConfig = yield select(getServerConfig);

    const query = {
      props: props.join(','),
      address: qs,
    };
    const path = `/parcel/${serverConfig.namespace}?${queryString.stringify(
      query,
    )}`;

    const results = yield call(API, 'get', 'api', path);

    yield put({
      type: 'SET_SEARCH_RESULTS',
      payload: {
        query,
        parcels: results.parcels,
      },
    });
    yield put({
      type: 'ADD_PARCELS',
      payload: {
        parcels: results.parcels,
      },
    });
  } catch (e) {
    console.error(e);
  }
}
